import { StoreState } from '@/core/models/store.interface';
import { LocationQuery } from 'vue-router';
import { Module } from 'vuex';
import { InternalJobFunction } from '../../internal-job-functions/internal-job-function.interface';
import { ApiResource } from './../../../models/api-resource.interface';
import { InternalJobFunctionService } from './internal-job-function.service';
const service = new InternalJobFunctionService();

export interface InternalJobFunctionState {
   internalJobFunctionsOverview?: ApiResource<Array<InternalJobFunction>>;
}

const InternalJobFunctionStore: Module<InternalJobFunctionState, StoreState> = {
   namespaced: true,
   state: {},
   getters: {},
   mutations: {
      SET_INTERNAL_JOB_FUNCTIONS_OVERVIEW(state, internalJobFunctionsOverview: ApiResource<Array<InternalJobFunction>>) {
         state.internalJobFunctionsOverview = internalJobFunctionsOverview;
      },
      ADD_INTERNAL_JOB_FUNCTION(state, internalJobFunction: InternalJobFunction) {
         if (!state.internalJobFunctionsOverview?.data) return;
         state.internalJobFunctionsOverview.data.push(internalJobFunction);
      },
      SET_INTERNAL_JOB_FUNCTION(state, internalJobFunction: InternalJobFunction) {
         const index = (state.internalJobFunctionsOverview?.data || []).findIndex((ijf) => ijf.id === internalJobFunction.id);
         if (index > -1) state.internalJobFunctionsOverview?.data.splice(index, 1, internalJobFunction);
      },
      REMOVE_INTERNAL_JOB_FUNCTION(state, internalJobFunctionId: number) {
         const index = (state.internalJobFunctionsOverview?.data || []).findIndex((ijf) => ijf.id === internalJobFunctionId);
         if (index > -1) state.internalJobFunctionsOverview?.data.splice(index, 1);
      },
   },
   actions: {
      async getInternalJobFunctions(context, payload: { tenantId: number; query?: LocationQuery }) {
         const internalJobFunctionsOverview = await service.getInternalJobFunctions(payload.tenantId, payload.query);
         context.commit('SET_INTERNAL_JOB_FUNCTIONS_OVERVIEW', internalJobFunctionsOverview);
         return internalJobFunctionsOverview;
      },
      async createInternalJobFunction(context, payload: { tenantId: number; internalJobFunction: InternalJobFunction }) {
         const response = await service.postInternalJobFunction(payload.tenantId, payload.internalJobFunction);
         context.commit('ADD_INTERNAL_JOB_FUNCTION', response);
         return response;
      },
      async changeInternalJobFunction(
         context,
         payload: { tenantId: number; internalJobFunctionId: number; internalJobFunction: InternalJobFunction }
      ) {
         const response = await service.putInternalJobFunction(
            payload.tenantId,
            payload.internalJobFunctionId,
            payload.internalJobFunction
         );
         context.commit('SET_INTERNAL_JOB_FUNCTION', response);
         return response;
      },
      async removeInternalJobFunction(context, payload: { tenantId: number; internalJobFunctionId: number }) {
         const response = await service.deleteInternalJobFunction(payload.tenantId, payload.internalJobFunctionId);
         context.commit('REMOVE_INTERNAL_JOB_FUNCTION', payload.internalJobFunctionId);
         return response;
      },
   },
};

export default InternalJobFunctionStore;
